import styled from 'styled-components';
import PropTypes from 'prop-types';

const Container = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: ${({ variant }) => (variant === 'light' ? '#fff' : '#000')};

  div {
    margin-top: -18px;
  }
`;

const Splash = ({ variant }) => (
  <Container variant={variant}>
    <div className={`splash-icon ${variant}`} />
  </Container>
);

Splash.propTypes = {
  variant: PropTypes.string,
};

export default Splash;
